import { useState, useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
// services
import * as exhibitorLeadCaptureService from '../../services/exhibitorLeadCaptureService'
import * as webBridgeService from '../../services/webBridgeService'
// styles
import styles from "./Index.css"

const Index = ({ user }) => {
    const location = useLocation()
    const passedState = location.state
    const [exhibitorInfo, setExhibitorInfo] = useState({})
    const [exhibitorLeadCaptureInfo, setExhibitorLeadCaptureInfo] = useState({})
    const exhibitorLeadCaptureInfoRef = useRef(null);
    if (exhibitorLeadCaptureInfoRef === null || exhibitorLeadCaptureInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            exhibitorLeadCaptureInfoRef.current = exhibitorLeadCaptureService.getExhibitorLeadCapture();
        }
        else {
            let passedData = {
                clientId: passedState.clientId,
                clientName: passedState.clientName,
                leadCaptureId: passedState.leadCaptureId,
                leadCaptureName: passedState.leadCaptureName,
                exhibitorId: passedState.exhibitorId,
            }
            exhibitorLeadCaptureInfoRef.current = passedData
        }

    }

    useEffect(() => {
        const interval = setInterval(() => checkExhibitorLeadCapture(), (300)) // run events fetch every .3 seconds
        return () => clearInterval(interval)
    }, [])
    const checkExhibitorLeadCapture = () => {
        // Update clientevent with every render when its value has changed.
        let savedExhibitorLeadCapture = exhibitorLeadCaptureService.getExhibitorLeadCapture();
        if (exhibitorLeadCaptureInfoRef.current && exhibitorLeadCaptureInfoRef.current.leadCaptureId !== undefined &&
            savedExhibitorLeadCapture && savedExhibitorLeadCapture.leadCaptureId !== undefined && savedExhibitorLeadCapture.exhibitorId !== undefined &&
            (savedExhibitorLeadCapture.leadCaptureId !== exhibitorLeadCaptureInfoRef.current.leadCaptureId ||
            savedExhibitorLeadCapture.exhibitorId !== exhibitorLeadCaptureInfoRef.current.exhibitorId)) {
            setExhibitorLeadCaptureInfo(savedExhibitorLeadCapture)
            exhibitorLeadCaptureInfoRef.current = savedExhibitorLeadCapture;
        }
    }
    const fetchExhibitor = async (exhibitorId) => {
        let exhibitor = await webBridgeService.fetchExhibitorById(exhibitorId)
        if (exhibitor) {
            setExhibitorInfo(exhibitor);
        }
    }
    useEffect(() => {
        // get exhibitor and lead capture event?
        if (exhibitorLeadCaptureInfo && exhibitorLeadCaptureInfo.exhibitorId) {
            fetchExhibitor(exhibitorLeadCaptureInfo.exhibitorId);
        }
    }, [exhibitorLeadCaptureInfo])
    useEffect(() => {
        // check if entry is stored
        // store into local object
        let localExhibitorLeadCapture = exhibitorLeadCaptureService.getExhibitorLeadCapture()
        if (localExhibitorLeadCapture) {
            setExhibitorLeadCaptureInfo(localExhibitorLeadCapture)
        }
    }, [])
    return (
        <>
            <main className="page-area">
                <div id="landing-area">
                    <div>
                        <h1>
                            Hello, {user ? user.Role : 'please sign in'}
                        </h1>

                        <div>
                            <h4>Welcome {user.firstName} {user.lastName}</h4>
                            <br /><br />
                            <div>
                                <h2>Options for :<br />{exhibitorLeadCaptureInfo ? exhibitorLeadCaptureInfo.leadCaptureName : null}
                                    <br />{exhibitorInfo && exhibitorInfo.firstName!== undefined? exhibitorInfo.firstName + ' ' + exhibitorInfo.lastName + '(' + exhibitorInfo.organization + ')' : null} </h2>
                                <br /><br />
                                *For previous events use Archived Events link or dropdown in header.
                            </div>
                            <div>
                                <ul className={styles.ulLanding} style={{
                                    textAlign: "left"
                                }}>
                                    <li style={{
                                        listStyleType: "none"
                                    }}><h3><strong>Lead Retrieval</strong></h3></li>
                                    <li title="Download or email lead retrieval data."> <Link to={`/ExhibitorLeads`} state={{ exhibitorAccount: exhibitorInfo, user: user }}><strong>Event Data Download/Email</strong></Link></li>
                                    <li title="Setup qualifiers for lead retrieval."> <Link to={`/QualifierManager`} state={{ exhibitorAccount: exhibitorInfo, user: user }}><strong>Qualifiers Admin</strong></Link></li>
                                    <li title="Lookup Passcodes for smithbucklin LR app."> <Link to={`/ExhibitorPasscodes`} state={{ exhibitorAccount: exhibitorInfo, user: user }}><strong>Passcode Lookup</strong></Link></li>
                                    {user.Role === "Admin" || user.Role === "SuperAdmin" ?
                                        <>
                                            <li title="View and download purchase invoices."> <Link to={`/GenerateInvoice`} state={{ exhibitorAccount: exhibitorInfo, user: user }}><strong>View Purchase Invoice</strong></Link></li>
                                            <li title="Access older events."> <Link to={`/ArchivedEvents`} state={{ exhibitorAccount: exhibitorInfo, user: user }}><strong>Archived Events</strong></Link></li>
                                            <li style={{
                                                listStyleType: "none"
                                            }} ></li>
                                            <li style={{
                                                listStyleType: "none"
                                            }}><h3><strong>Administrative</strong></h3></li>
                                            <li title="Setup secondary accounts with limited ability."> <Link to={`/ExhibitorSetup`} state={{ exhibitorAccount: exhibitorInfo, user: user }}><strong>Exhibitor Accounts</strong></Link></li>
                                        </>
                                        : <></>
                                    }
                                    {user.Role === "SuperAdmin" ?
                                        <>
                                            <li title="Admin all accounts."> <Link to={`/AccountsAdmin`}><strong>All Accounts Admin</strong></Link></li>
                                            <li title="Review logs."> <Link to={`/elmah`} target="_blank"><strong>ELMAH logs</strong></Link></li>
                                        </>
                                        : <></>
                                    }
                                    <li style={{
                                        listStyleType: "none"
                                    }}></li>
                                    <li style={{
                                        listStyleType: "none"
                                    }}><h3><strong>Profile</strong></h3></li>
                                    <li title="Manage account settings."> <Link to={`/ManageAccount`} ><strong>Manage Account</strong></Link></li>
                                    <li title="Contact site staff."> <Link to={`/Contact`} target="_blank"><strong>Contact Us</strong></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Index